import angular from 'angular';
import {Enum} from '../../shared/enum/index';
import confirmActivateInsurancePopupController from '../../shared/popup/confirm-activate-insurance-popup/confirm-activate-insurance-popup.controller';


export class InsuranceNnwDetailsController {
    filterText = '';

    /*@ngInject*/
    constructor($http, $state, $stateParams, OrderNnw, Person, Document, $scope, LeftNav, $q, pageSettings,
                helper, $mdPanel) {
        let vm = this;
        vm.cloakView = true;
        vm._mdPanel = $mdPanel;

        this.$http = $http;
        this.Enum = Enum;
        this.LeftNav = LeftNav;
        this.pageSettings = pageSettings;
        this.$state = $state;

        vm.insurancePersonStatuses = [];
        vm.paymentStatuses = [];

        _.each(Enum.INSURANCE_PERSON_STATUS, data => {
            helper.translate('ENUM.INSURANCE_PERSON_STATUS.' + data)
                .then(translated => {
                    vm.insurancePersonStatuses.push({label: translated, id: data});
                });
        });

        _.each(Enum.PAYMENT_STATUS, data => {
            helper.translate('ENUM.PAYMENT_STATUS.' + data)
                .then(translated => {
                    vm.paymentStatuses.push({label: translated, id: data});
                });
        });

        const listener = {};
        listener.getInsuranceById = data => {
            console.log(data.data);
            vm.insurance = data.data;
            vm.insurance.person.bornDate = new Date(vm.insurance.person.bornDate);
            vm.insuranceStatus = vm.insurance.status;
            vm.paymentStatus = vm.insurance.paymentStatus;
        };

        vm.getInsurance = function() {
            OrderNnw.getById($stateParams.id)
                .then(listener.getInsuranceById);
        };

        // LISTENERS
        const loadingBarDisabler = $scope.$on('cfpLoadingBar:completed', function() {
            vm.cloakView = false;
            loadingBarDisabler();
        });

        // ACTIONS
        vm.showDetails = insurance => {
            console.log(insurance);
        };

        vm.downloadCertificate = function(item) {
            console.log(item);
            Document.printNnw(item.document.id, item.person.email, item.accessToken);
        };

        vm.changesStatues = () => {
            let request = {
                paymentStatus: vm.paymentStatus,
                insurancePersonStatus: vm.insuranceStatus
            };
            if(vm.paymentStatus === Enum.PAYMENT_STATUS.COMPLETED && vm.insuranceStatus === Enum.INSURANCE_PERSON_STATUS.ACTIVE) {
                confirmActivateInsurancePopup(request);
            } else {
                InsurancePerson.changeStatuses($stateParams.id, request)
                    .then(listener.getInsuranceById);
            }
        };

        vm.updatePerson = () => {
            Person.update(vm.insurance.person)
                .then(() => {
                    vm.getInsurance();
                    helper.showOperationSuccessToast();
                })
                .catch(() => {
                    helper.showOperationFailedToast();
                });
        };

        let confirmActivateInsurancePopup = (statuses) => {
            let position = vm._mdPanel.newPanelPosition();
            let config = {
                attachTo: angular.element(document.body),
                controller: 'confirmActivateInsurancePopupController',
                controllerAs: 'vm',
                disableParentScroll: this.disableParentScroll,
                template: require('./../../shared/popup/confirm-activate-insurance-popup/confirm-activate-insurance-popup.pug'),
                hasBackdrop: true,
                panelClass: 'confirm-activate-insurance-popup md-whiteframe-6dp',
                position: position,
                trapFocus: true,
                targetEvent: undefined,
                zIndex: 9,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: true,
                fullscreen: false,
                resolve: {
                    insuranceData: () => vm.insurance,
                    statuses: () => statuses
                },
                locals: {
                    onClose: (data, s) => {
                        vm.getInsurance();
                    }
                }
            };

            vm._mdPanel.open(config);
        };
    }

    $onInit() {
        this.LeftNav.setActive('clients', 'main.insuranceOffers');
        this.pageSettings.setTitle('APPLICATION.TITLE.INSURANCE');
        this.pageSettings.setState('main.insuranceOffers');
        this.pageSettings.setTheme('client');
        this.getInsurance();
    }
}

export default angular.module('ngOskCrmApp.main.insuranceNnwDetails', [confirmActivateInsurancePopupController])
    .component('insuranceNnwDetails', {
        template: require('./insurance-nnw-details.pug'),
        controller: InsuranceNnwDetailsController,
        controllerAs: 'vm'
    })
    .name;


//
//
// function($scope, element){
//
//     var variant = document.getElementsByClassName('info-headers_variant');
//     console.log(variant);
//     var wrappedVariant = angular.element(variant);
//     console.log(wrappedVariant);
//
//     if (vm.insurance.productOczfp.group = 'SILVER') {
//         variant.style.color = 'silver';
//     } else if (vm.insurance.productOczfp.group = 'GOLD'){
//         variant.style.color = 'gold';
//     } else {
//         variant.style.color = 'black';
//     }
// };



// WEBPACK FOOTER //
// ./client/app/main/insurance-nnw-details/insurance-nnw-details.component.js